var config = require('./store-locator-config');
var templates = require('./store-locator-templates');
var utils = require('./store-locator-utils');
var { i18n } = require('@/commons/utils');

const { StoreFinder } = require('@/commons/component/store-finder');

module.exports.init = function() {
  const storeFinder = new StoreFinder({
    container: cube.$('.decathlon-woosmap-store-locator-map .store-selection'),
    template: 'store-locator',
  });

  $.getScript(
    'https://api.map.baidu.com/api?v=2.0&ak=oUQDfIp2b7qNxIuSaghaeip7',
    function() {
      let map = new BMap.Map(woosmap.$('#my-map')[0]);

      map.centerAndZoom(
        new BMap.Point(config.centerlng, config.centerLat),
        config.zoom
      ); // center of China. Careful, lat/long are opposite to the Google Maps ones.
      // add ScaleControl

      // add scale control and zoom control tool in bottom right
      map.addControl(
        new BMap.ScaleControl({ anchor: BMAP_ANCHOR_BOTTOM_RIGHT })
      );
      map.addControl(
        new BMap.NavigationControl({ anchor: BMAP_ANCHOR_BOTTOM_RIGHT })
      );

      let mapView = new woosmap.TiledView(map, {
        gentleCenter: true,
        style: config.markersStyle,
        tileStyle: config.tilesStyle,
        breakPoint: 8,
      });

      mapView.padding = {
        left: 150 + 12,
      };

      var renderer = new woosmap.TemplateRenderer(templates.infobox);
      var infoBoxOptions = {
        disableAutoPan: false,
        pixelOffset: {
          width: -140,
          height: -300,
        },
        boxClass: 'infoBox',
        closeBoxMargin: '8px',
        closeBoxURL: '/assets/images/woosmap-infobox-close-white.svg',
        infoBoxClearance: {
          width: 1,
          height: 1,
        },
      };
      let locatorWindow = new woosmap.LocatorWindow(
        map,
        renderer,
        infoBoxOptions
      );

      mapView.bindTo('selectedStore', locatorWindow);

      // On opening : set the '#infobox-itinerary' link's href
      // to the baidu / direction URL
      locatorWindow.setOpeningCallback(() => {

        $('.woosmap-infobox__store-pagelink').on('click', function(e) {
          // Avoid scoll to top
          e.cancelBubble = true;
          e.preventDefault();
          e.stopPropagation();

          // Get STORE ID in clicked link
          var link = $(this);
          var storeId = link.data('store-id');

          // Get the 'real' link to the store (in bottom cartridge)
          var realStoreLink = $('.st-l-wrapper a[href*="' + storeId + '"]');

          // If real link is present : redirect to real destination
          if (realStoreLink.length) document.location = realStoreLink.attr('href');

        });


        const { geometry } = locatorWindow.get('selectedStore');
        if (!geometry) return; // exit if no geometry

        const [lat, lng] = geometry.coordinates;
        if (!lat || !lng) return; // exist if not coordinates

        const url = `${i18n(config.provider)}${lng},${lat}&output=html`;

        cube.$id('infobox-itinerary').href = url;

        map.panTo(new BMap.Point(lat, lng));

      });

      const goToPosition = ({ longitude, latitude }) => {
        const newPosition = new window.BMap.Point(longitude, latitude);
        map.setZoom(13);
        map.panTo(newPosition);
      };

      // when store-finder recieve a new stores list
      // go to first one coordinates and close previous popin (if any)
      storeFinder.on('stores', stores => {
        const [longitude, latitude] = stores[0].geometry.coordinates;
        goToPosition({ longitude,  latitude });
        locatorWindow.set('selectedStore', stores[0]);
        storeFinder.seeMoreStores(10);
      });
      storeFinder.on(
        'click',
        '.store-selection__cta-zone',
        ({ geometry, store: properties }) => {
          // Reconstruct a 'store' object
          const store = { geometry, properties };
          // Set as 'selectedStore'
          locatorWindow.set('selectedStore', store);
          const [longitude, latitude] = geometry.coordinates;
          goToPosition({ longitude, latitude });
        }
      );

      woosmap.$('.decathlon-woosmap-show-all-stores').click(function() {
        $(window).scrollTo($('.storelist'), 1200,{
            offset:-66
          });
      });



      woosmap.$('.store-selection__search-form .js-input').click(function(e) {
        $(e.target).select()
      });


    }
  );
};



// WEBPACK FOOTER //
// ./src/modules-es5/pages/store-locator/store-locator-china.js